// extracted by mini-css-extract-plugin
export default {"spinner":"loading_spinner__x6VYQ","changeContent":"loading_changeContent__deJUQ"};